/**
 * What the UI does with something the viewer is not allowed to use (CT-5569).
 *
 * `hide`: the section / action is not rendered at all (not even in the menu), so the user is
 * unaware it exists. `lock`: it stays visible but disabled, with an explanation (HubSpot / Jira
 * style). The final rule is pending with JJ (cross-sell impact), so `hide` is the default.
 *
 * RULE: flipping `DEFAULT_UNAUTHORIZED_MODE` is the ONLY edit needed to switch the whole app.
 * Call sites never read this constant: they go through `usePermission`, `<Can>`,
 * `<RequirePermission>` or `filterMenuByPermission`, which resolve the mode for them (a
 * per-call `mode` override is the only exception, and it is passed to those APIs, not read).
 */
export const UNAUTHORIZED_MODES = Object.freeze({ HIDE: 'hide', LOCK: 'lock' });

export const DEFAULT_UNAUTHORIZED_MODE = UNAUTHORIZED_MODES.HIDE;

/** Where `<RequirePermission>` sends a viewer who may not see the route (shell home). */
export const NO_ACCESS_REDIRECT_PATH = '/';
